var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgE2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#EFBF27",
    d: "M237.588,158.878v7.588c0,3.05-2.473,5.523-5.523,5.523H26.627c-3.05,0-5.523-2.473-5.523-5.523v-7.588 c0-3.05,2.473-5.523,5.523-5.523h205.438C235.115,153.355,237.588,155.828,237.588,158.878z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.936,
    y: 171.989,
    fill: "#EEEEEE",
    width: 198.82,
    height: 77.495
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.936,
    y: 171.989,
    fill: "#AEAEAE",
    width: 198.82,
    height: 7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13BF6D",
    d: "M211.156,114.639v38.72h-104.51l-0.69-7l-0.64-6.58l6.39-6.4l22.27-22.27c3.15-3.15,8.54-0.92,8.54,3.53 v22.26l25.78-25.79c3.15-3.15,8.54-0.92,8.54,3.53v22.26l25.78-25.79C205.766,107.958,211.156,110.189,211.156,114.639z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#71C1E8",
    points: "106.646,153.359 47.536,153.359 48.226,146.359 55.156,76.198 99.026,76.198 105.316,139.779  105.956,146.359  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#4BA4C7",
    points: "106.646,153.359 47.536,153.359 48.226,146.359 105.956,146.359  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#EEEEEE",
    points: "99.027,76.194 55.156,76.194 56.769,59.837 97.415,59.837  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0E9B6D",
    d: "M112.808,144.555l-1.102-11.176l-6.39,6.4l0.64,6.58l0.69,7h104.51v-7h-96.358 C113.77,146.359,112.909,145.579,112.808,144.555z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#EEEEEE",
    points: "99.027,76.194 55.156,76.194 56.769,59.837 97.415,59.837  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0C020",
    d: "M133.889,84.732c-3.961-1.309-8.051-2.453-10.348-12.345c-2.115,9.112-5.504,10.745-10.348,12.345 c7.9,2.61,9.092,6.933,10.348,12.345C125.706,87.747,129.287,86.253,133.889,84.732z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.951,97.678c-1.147-4.945-1.905-8.212-8.591-10.421c-2.43-0.803-2.424-4.25,0-5.051 c4.025-1.33,6.684-2.209,8.591-10.422c0.633-2.73,4.546-2.737,5.181,0c1.95,8.399,4.863,9.193,8.591,10.421 c2.43,0.803,2.424,4.25,0,5.051c-3.881,1.282-6.686,2.209-8.591,10.421C125.496,100.421,121.588,100.421,120.951,97.678z  M119.431,84.793c1.914,1.314,3.222,2.815,4.164,4.403c1.141-2.017,2.462-3.405,3.934-4.439c-1.411-1.01-2.778-2.44-3.977-4.601 C122.365,82.289,120.979,83.73,119.431,84.793z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0C020",
    d: "M46.383,53.895c-3.961-1.309-8.051-2.453-10.348-12.345c-2.115,9.112-5.504,10.745-10.348,12.345 c7.9,2.61,9.092,6.933,10.348,12.345C38.2,56.91,41.781,55.416,46.383,53.895z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.444,66.841c-1.147-4.945-1.905-8.212-8.591-10.421c-2.43-0.803-2.424-4.25,0-5.051 c4.025-1.33,6.684-2.209,8.591-10.422c0.633-2.73,4.546-2.737,5.181,0c1.95,8.399,4.863,9.193,8.591,10.421 c2.43,0.803,2.424,4.25,0,5.051c-3.881,1.282-6.686,2.209-8.591,10.421C37.989,69.584,34.082,69.584,33.444,66.841z M31.925,53.956 c1.914,1.314,3.222,2.815,4.164,4.403c1.141-2.017,2.462-3.405,3.934-4.439c-1.411-1.01-2.778-2.44-3.977-4.601 C34.859,51.452,33.473,52.894,31.925,53.956z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13BF6D",
    d: "M77.092,30.272H51.651c-11.878,0-21.508-9.629-21.508-21.508V6.516h25.441 c11.878,0,21.508,9.629,21.508,21.508V30.272z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#13BF6D",
    d: "M77.092,47.152h25.441c11.878,0,21.508-9.629,21.508-21.508v-2.248H98.6 c-11.878,0-21.508,9.629-21.508,21.508V47.152z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.083,
    y: 192.764,
    fill: "#EFBF27",
    width: 11.608,
    height: 11.608
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.569,
    y: 192.764,
    fill: "#EFBF27",
    width: 11.608,
    height: 11.608
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.056,
    y: 192.764,
    fill: "#EFBF27",
    width: 11.608,
    height: 11.608
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.542,
    y: 192.764,
    fill: "#EFBF27",
    width: 11.608,
    height: 11.608
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.028,
    y: 192.764,
    fill: "#EFBF27",
    width: 11.608,
    height: 11.608
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.514,
    y: 192.764,
    fill: "#EFBF27",
    width: 11.608,
    height: 11.608
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.001,
    y: 192.764,
    fill: "#EFBF27",
    width: 11.608,
    height: 11.608
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.083,
    y: 217.128,
    fill: "#EFBF27",
    width: 11.608,
    height: 11.608
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.569,
    y: 217.128,
    fill: "#EFBF27",
    width: 11.608,
    height: 11.608
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.514,
    y: 217.128,
    fill: "#EFBF27",
    width: 11.608,
    height: 11.608
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.001,
    y: 217.128,
    fill: "#EFBF27",
    width: 11.608,
    height: 11.608
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.86,
    y: 217.128,
    fill: "#71C1E8",
    width: 52.973,
    height: 32.361
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M102.856,241.983h-62.92c-1.381,0-2.5-1.119-2.5-2.5s1.119-2.5,2.5-2.5h62.92c1.381,0,2.5,1.119,2.5,2.5 S104.237,241.983,102.856,241.983z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M218.756,241.983h-3c-1.381,0-2.5-1.119-2.5-2.5s1.119-2.5,2.5-2.5h3c1.381,0,2.5,1.119,2.5,2.5 S220.137,241.983,218.756,241.983z M205.756,241.983h-49.92c-1.381,0-2.5-1.119-2.5-2.5s1.119-2.5,2.5-2.5h49.92 c1.381,0,2.5,1.119,2.5,2.5S207.137,241.983,205.756,241.983z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C4E4FD",
    d: "M92.703,139.254l-3.944-39.872c-0.136-1.374,0.868-2.598,2.242-2.734c1.376-0.135,2.598,0.868,2.734,2.242 l3.944,39.872c0.136,1.374-0.868,2.598-2.242,2.734C94.07,141.631,92.839,140.634,92.703,139.254z M87.774,89.43l-0.295-2.985 c-0.136-1.374,0.868-2.598,2.242-2.734c1.376-0.131,2.598,0.868,2.734,2.242l0.295,2.985c0.136,1.374-0.868,2.598-2.242,2.734 C89.142,91.808,87.911,90.811,87.774,89.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C4E4FD",
    d: "M145.833,241.988H125.86c-1.381,0-2.5-1.119-2.5-2.5s1.119-2.5,2.5-2.5h17.473v-14.089 c0-1.381,1.119-2.5,2.5-2.5s2.5,1.119,2.5,2.5v16.589C148.333,240.869,147.213,241.988,145.833,241.988z M115.86,241.988h-3 c-1.381,0-2.5-1.119-2.5-2.5s1.119-2.5,2.5-2.5h3c1.381,0,2.5,1.119,2.5,2.5S117.241,241.988,115.86,241.988z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7E4B0",
    d: "M228.756,165.171h-3c-1.381,0-2.5-1.119-2.5-2.5s1.119-2.5,2.5-2.5h3c1.381,0,2.5,1.119,2.5,2.5 S230.137,165.171,228.756,165.171z M215.756,165.171H30.144c-1.381,0-2.5-1.119-2.5-2.5s1.119-2.5,2.5-2.5h185.612 c1.381,0,2.5,1.119,2.5,2.5S217.137,165.171,215.756,165.171z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.76,209.492c-1.38,0-2.5,1.12-2.5,2.5c0,1.37,1.12,2.5,2.5,2.5c1.37,0,2.49-1.13,2.49-2.5 C231.25,210.612,230.13,209.492,228.76,209.492z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.02,102.962c0.14-1.37-0.87-2.6-2.24-2.73c-1.36-0.14-2.6,0.87-2.73,2.24c-0.14,1.37,0.87,2.59,2.24,2.73 C53.539,105.363,54.883,104.422,55.02,102.962z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.89,121.652c-0.97,0.98-0.97,2.57,0,3.54c0.939,0.938,2.508,1.01,3.54,0c0.946-0.946,1.002-2.517,0-3.54 C122.48,120.712,120.84,120.712,119.89,121.652z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.191,192.764c0-1.381-1.119-2.5-2.5-2.5H44.083c-1.381,0-2.5,1.119-2.5,2.5v11.608c0,1.381,1.119,2.5,2.5,2.5h11.608 c1.381,0,2.5-1.119,2.5-2.5V192.764z M53.191,201.872h-6.608v-6.608h6.608V201.872z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.678,192.764c0-1.381-1.119-2.5-2.5-2.5H70.569c-1.381,0-2.5,1.119-2.5,2.5v11.608c0,1.381,1.119,2.5,2.5,2.5h11.608 c1.381,0,2.5-1.119,2.5-2.5V192.764z M79.678,201.872h-6.608v-6.608h6.608V201.872z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.056,190.264c-1.381,0-2.5,1.119-2.5,2.5v11.608c0,1.381,1.119,2.5,2.5,2.5h11.608c1.381,0,2.5-1.119,2.5-2.5v-11.608 c0-1.381-1.119-2.5-2.5-2.5H97.056z M106.164,201.872h-6.608v-6.608h6.608V201.872z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.542,190.264c-1.381,0-2.5,1.119-2.5,2.5v11.608c0,1.381,1.119,2.5,2.5,2.5h11.608c1.381,0,2.5-1.119,2.5-2.5v-11.608 c0-1.381-1.119-2.5-2.5-2.5H123.542z M132.65,201.872h-6.608v-6.608h6.608V201.872z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.028,190.264c-1.381,0-2.5,1.119-2.5,2.5v11.608c0,1.381,1.119,2.5,2.5,2.5h11.608c1.381,0,2.5-1.119,2.5-2.5v-11.608 c0-1.381-1.119-2.5-2.5-2.5H150.028z M159.137,201.872h-6.608v-6.608h6.608V201.872z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.623,192.764c0-1.381-1.119-2.5-2.5-2.5h-11.608c-1.381,0-2.5,1.119-2.5,2.5v11.608c0,1.381,1.119,2.5,2.5,2.5h11.608 c1.381,0,2.5-1.119,2.5-2.5V192.764z M185.623,201.872h-6.608v-6.608h6.608V201.872z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.109,192.764c0-1.381-1.119-2.5-2.5-2.5H203c-1.381,0-2.5,1.119-2.5,2.5v11.608c0,1.381,1.119,2.5,2.5,2.5h11.608 c1.381,0,2.5-1.119,2.5-2.5V192.764z M212.109,201.872H205.5v-6.608h6.608V201.872z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.691,214.628H44.083c-1.381,0-2.5,1.119-2.5,2.5v11.608c0,1.381,1.119,2.5,2.5,2.5h11.608c1.381,0,2.5-1.119,2.5-2.5 v-11.608C58.191,215.747,57.072,214.628,55.691,214.628z M53.191,226.236h-6.608v-6.608h6.608V226.236z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.178,214.628H70.569c-1.381,0-2.5,1.119-2.5,2.5v11.608c0,1.381,1.119,2.5,2.5,2.5h11.608c1.381,0,2.5-1.119,2.5-2.5 v-11.608C84.678,215.747,83.559,214.628,82.178,214.628z M79.678,226.236h-6.608v-6.608h6.608V226.236z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.123,214.628h-11.608c-1.381,0-2.5,1.119-2.5,2.5v11.608c0,1.381,1.119,2.5,2.5,2.5h11.608c1.381,0,2.5-1.119,2.5-2.5 v-11.608C190.623,215.747,189.503,214.628,188.123,214.628z M185.623,226.236h-6.608v-6.608h6.608V226.236z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.609,214.628H203c-1.381,0-2.5,1.119-2.5,2.5v11.608c0,1.381,1.119,2.5,2.5,2.5h11.608c1.381,0,2.5-1.119,2.5-2.5 v-11.608C217.109,215.747,215.99,214.628,214.609,214.628z M212.109,226.236H205.5v-6.608h6.608V226.236z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,251.983c6.313,0,225.055,0,241,0c1.381,0,2.5-1.119,2.5-2.5s-1.119-2.5-2.5-2.5h-17.25v-24.991 c0-1.38-1.12-2.5-2.49-2.5c-1.38,0-2.5,1.12-2.5,2.5v24.99h-67.927v-29.854c0-1.381-1.119-2.5-2.5-2.5H102.86 c-1.381,0-2.5,1.119-2.5,2.5v29.854H32.44v-72.495h193.82v27.504c0,1.37,1.12,2.5,2.5,2.5c1.37,0,2.49-1.13,2.49-2.5v-27.504 c5.889,0,8.837-3.988,8.837-8.022v-7.588c0-4.424-3.599-8.022-8.022-8.022H213.66v-36.213c0.033-6.676-8.121-10.021-12.81-5.3 l-21.51,21.52v-16.22c0.031-6.681-8.158-10.019-12.81-5.3l-21.51,21.52v-16.22c0-6.718-8.176-10.001-12.81-5.3l-5.25,5.24 c-0.97,0.98-0.97,2.56,0,3.54c0.95,0.94,2.59,0.94,3.54,0l5.24-5.25c1.646-1.582,4.266-0.446,4.28,1.77v22.26 c0,2.243,2.716,3.325,4.26,1.76l25.78-25.79c1.645-1.583,4.266-0.446,4.28,1.77v22.26c0,2.252,2.722,3.32,4.26,1.76l25.78-25.79 c1.65-1.586,4.266-0.442,4.28,1.77v36.213h-99.753l-1.001-10.139l8.454-8.454c0.97-0.97,0.978-2.552,0-3.53 c-0.95-0.95-2.59-0.95-3.54,0l-5.549,5.555c-9.858-99.822-3.022-30.601-7.368-74.696c-0.126-1.28-1.202-2.255-2.488-2.255H79.592 v-7.685h22.941c13.238,0,24.008-10.77,24.008-24.008v-2.248c0-1.381-1.119-2.5-2.5-2.5H98.6c-7.73,0-14.614,3.676-19.008,9.368 v-2.239c0-13.238-10.77-24.008-24.008-24.008h-25.44c-1.381,0-2.5,1.119-2.5,2.5v2.248c0,13.238,10.77,24.008,24.008,24.008h22.94 c0,8.359,0,15.106,0,24.564H56.769c-1.286,0-2.362,0.975-2.488,2.255c-2.489,25.241-1.107,11.271-3.251,32.921 c-0.128,1.427,0.896,2.597,2.24,2.74c1.38,0.14,2.6-0.87,2.74-2.24l1.41-14.31h39.34l7.129,72.153H50.291l3.749-37.943 c0.14-1.37-0.87-2.6-2.24-2.73c-1.38-0.15-2.6,0.87-2.73,2.24l-3.797,38.433H26.627c-4.423,0-8.022,3.599-8.022,8.022v7.588 c0,3.855,2.766,8.022,8.835,8.022v72.496H7.5c-1.381,0-2.5,1.119-2.5,2.5S6.119,251.983,7.5,251.983z M131.846,219.628h21.486 v27.354h-21.486V219.628z M105.36,219.628h21.486v27.354H105.36V219.628z M98.6,25.896h22.939 c-0.135,10.366-8.609,18.756-19.006,18.756H85.322l10.697-6.098c1.199-0.684,1.617-2.21,0.934-3.41 c-0.683-1.199-2.21-1.617-3.41-0.934l-13.711,7.816C81.225,32.909,89.099,25.896,98.6,25.896z M58.778,20.438l10.418,7.333H51.651 c-10.396,0-18.87-8.391-19.006-18.755h22.939c9.555,0,17.467,7.094,18.794,16.288L61.656,16.35 c-1.128-0.795-2.688-0.524-3.483,0.605C57.378,18.084,57.649,19.644,58.778,20.438z M57.915,73.694l1.12-11.358h36.115l1.12,11.358 H57.915z M26.627,169.488c-1.667,0-3.022-1.356-3.022-3.022v-7.588c0-1.667,1.356-3.022,3.022-3.022c183.222,0,203.509,0,205.286,0 c0.107,0,0.148,0,0.152,0h0c1.667,0,3.022,1.356,3.022,3.022v7.588c0,1.667-1.356,3.022-3.022,3.022H26.627z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgE2);
export default __webpack_public_path__ + "static/media/E2.25a690b5c4a84efbe0fb7f25a255b521.svg";
export { ForwardRef as ReactComponent };